<template>
  <div class="g-collapse-panel-item" >
    <div :class="['panel-title',status ? 'title-border': '']" @click.stop="handlePanelItemClick">
      <!-- <i :class="['arrow', status ? 'arrow-open' : '']"></i> -->
      <div class="header">
        <slot name="header"></slot>
      </div>
      <img src="@/assets/tms/collapse_icon.png" :class="['arrow',status ? 'arrow-open' : '']" />
    </div>
    <transition-collapse>
      <div class="content" v-show="status">
        <div class="inner-content">
          <slot name="content"></slot>
        </div>
      </div>
    </transition-collapse>
  </div>
</template>

<script>
import TransitionCollapse from './TransitionCollapse'
export default {
  // 父组件实例
  inject: ['collapseInstace'],
  props: {
    // 当前面板标识
    name: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      status: false
    }
  },
  components: { TransitionCollapse },
  methods: {
    // 点击折叠状态交给父组件处理
    handlePanelItemClick() {
      this.$parent.toggle(this)
    },
    // 根据初始状态的value，设置展开项
    init() {
      if (this.name === this.collapseInstace.value) {
        this.status = true
      }
    }
  },
  mounted() {
    // 初始化
    this.init()
  }
}
</script>

<style lang="less">
.g-collapse-panel-item {
  margin: -1px;
  .panel-title {
    display: flex;
    justify-content: space-between;
    padding:16px;
    padding-left:20px;
    cursor: pointer;
    position: relative;
    border: 1px solid #dcdee2;
    border-radius: 8px;
  }
  .title-border {
    border-radius: 8px 8px 0 0;
  }
  .header {
    flex:1
  }
  .content {
    margin-top:-3px;
    padding: 20px;
    border-left: 1px solid #dcdee2;
    border-right: 1px solid #dcdee2;
    border-bottom: 1px solid #dcdee2;
    border-radius: 0 0 8px 8px;
  }
  .arrow {
    width:24px;
    height:24px;
    display: inline-block;
    transition: all 0.5s ease 0s;
  }
  .arrow-open {
    transform: rotate(180deg);
  }
}
</style>
